var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var PlayApps = function PlayApps(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M8.286 3.617A1.5 1.5 0 0 0 6 4.895v14.21a1.5 1.5 0 0 0 2.286 1.278l11.546-7.105a1.5 1.5 0 0 0 0-2.556L8.286 3.617Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default PlayApps;